if(['/pages/b2b-outside-de', '/pages/b2b-de'].includes(location.pathname)) {
  const loop = setInterval(() => {
    if($(".formbuilder-text").length) {
      clearInterval(loop);
      $(".formbuilder-text").each((ind, item) => {
          const input = $(item).find("input");
          input.attr("placeholder", " ")
      });
    }
  }, 200);

  setTimeout(() => {
    loop && clearInterval(loop);
  }, 20000)
}
